import { FormControl, FormGroup } from '@angular/forms';
import { CODOutForDelivery } from 'src/app/core/models/reports/reports.model';
import { Options } from '../../../shared/report-format/report-format.constants';

export const CONSTS = {
  HEADER: $localize`COD Out for Delivery`,
  LABEL: $localize`Date`,
};
export const FILE_NAME = 'COD-Out-For-Delivery-Report';

export const PDF_REPORT = {
  NAME: 'COD OUT FOR DELIVERY REPORT',
  HEADER: {
    LOCATION: 'Location:',
  },
  COLUMNS: [
    'Date'.toUpperCase(),
    'Driver'.toUpperCase(),
    'Trackno'.toUpperCase(),
    'Customer'.toUpperCase(),
    'City'.toUpperCase(),
    'Amt'.toUpperCase(),
  ],
  DATA_FIELDS: [
    'date',
    'driver',
    'trackno',
    'customer',
    'city',
    'amt',
  ] as (keyof CODOutForDelivery)[],
};

type CODOutForDeliveryFormField = {
  date: FormControl<Date>;
  reportFormat: FormControl<Options>;
};

export type CODOutForDeliveryFormGroup =
  FormGroup<CODOutForDeliveryFormField> | null;
